import axios from 'axios'
import { OffsetReason } from 'src/core/models'

export async function getOffsetReasonListtAPI(): Promise<OffsetReason[]> {
  const { data } = await axios.get<OffsetReason[]>('/api/v1/offset_reasons/')
  return data
}
